import React from 'react'
import { MatchedSearchableItem } from './SelectEntitiesForm.types'
import {
  SelectedEntitiesContext,
  SelectEntitiesModalQueryContext
} from './context'

export const compareScore = (
  a: MatchedSearchableItem,
  b: MatchedSearchableItem
): number => {
  if (a.score === b.score) {
    return a.item.text.localeCompare(b.item.text) // sort alphabetically
  }
  return a.score - b.score
}

export const SortedEntitiesBasedOnSelection: React.FC = ({ children }) => {
  const { items, ...context } = React.useContext(
    SelectEntitiesModalQueryContext
  )

  const { selectedIds } = React.useContext(SelectedEntitiesContext)

  const sortedItems = React.useMemo(() => {
    // selected item has more weight that non selected
    // if both items selected or not selected, compare them by score
    // if score is the same, sort alphabetically
    return items.sort((a, b) => {
      const aSelected = selectedIds.has(a.item.id)
      const bSelected = selectedIds.has(b.item.id)
      if (aSelected !== bSelected) {
        return aSelected ? -1 : 1
      }

      return compareScore(a, b)
    })
  }, [items]) // don't watch for selectedIds changes, otherwise, when the user selects an element, it will jump up the list

  return (
    <SelectEntitiesModalQueryContext.Provider
      value={{
        items: sortedItems,
        ...context
      }}
    >
      {children}
    </SelectEntitiesModalQueryContext.Provider>
  )
}
